import { render, staticRenderFns } from "./DashboardIndicators.vue?vue&type=template&id=3faf6634&"
import script from "./DashboardIndicators.vue?vue&type=script&lang=js&"
export * from "./DashboardIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3faf6634')) {
      api.createRecord('3faf6634', component.options)
    } else {
      api.reload('3faf6634', component.options)
    }
    module.hot.accept("./DashboardIndicators.vue?vue&type=template&id=3faf6634&", function () {
      api.rerender('3faf6634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/dashboard/DashboardIndicators.vue"
export default component.exports